import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from '@app/app.module';
import {environment} from './environments/environment';
import {merge} from 'lodash-es';
import {DCP_API_CONFIG} from '@app/config/DcpApiConfig';
import {APP_CONFIG} from '@app/config/AppConfig';

if (environment.production) {
  enableProdMode();
}

const IAS_IDP_ACTIVE_FLAG: string = 'iasActiveFlag';

const bootstrap = () => {
  Promise.all([
    fetch('/assets/config.common.json'),
    fetch('/assets/config.routing.json'),
    fetch('/assets/config.env.json')
  ]).then(([commonConfig, routingConfig, envConfig]) => {
    return Promise.all([commonConfig.json(), routingConfig.json(), envConfig.json()]);
  }).then(([commonConfig, routingConfig, envConfig]) => {
    // Retrieve the flag from sessionStorage
    let isIasActive = window.sessionStorage.getItem(IAS_IDP_ACTIVE_FLAG);

    // Check if the flag is not already set to 'true'
    if (isIasActive !== 'true') {
      // Parse the URL query parameters
      const urlParams = new URLSearchParams(window.location.search);

      // Check if the 'namespace' query parameter is equal to 'udex'
      isIasActive = urlParams.get('namespace') === 'udex' ? 'true' : 'false';

      // If the flag is set to 'true', update sessionStorage
      if (isIasActive === 'true') {
        window.sessionStorage.setItem(IAS_IDP_ACTIVE_FLAG, 'true');
      }
    }

    // If the flag is set to 'true', extend the authentication configuration
    if (isIasActive === 'true') {
      commonConfig.authentication = {
        ...commonConfig.authentication,       // Spread the existing authentication configuration
        ...commonConfig.authenticationIas     // Spread the IAS-specific authentication configuration
      };

      // same with envConfig
      envConfig.authentication = {
        ...envConfig.authentication,
        ...envConfig.authenticationIas
      };
    }
    const config = merge(commonConfig, envConfig, routingConfig, DCP_API_CONFIG);
    platformBrowserDynamic([{provide: APP_CONFIG, useValue: config}])
      .bootstrapModule(AppModule)
      .catch((err) => console.error(err));  // NOSONAR
  });
};


if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
